export default "__VITE_ASSET__DPB_VeoR__"